var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.data.length>0)?_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"init":_vm.updatafun(),"id":"ConsumptionStructure"}}):_c('NoData')],1)}
var staticRenderFns = []

export { render, staticRenderFns }